import React, { useMemo } from 'react';
import { regexForStartLinks } from 'appConstants';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IDownloadAppAndroidUrlField {
	changeDownloadAppAndroidUrl: (value: string) => void;
	isShowCustomerLoyaltyProgramButtons: boolean;
}

const DownloadAppAndroidUrlField: React.FC<IDownloadAppAndroidUrlField> = ({
	changeDownloadAppAndroidUrl,
	isShowCustomerLoyaltyProgramButtons,
}) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(
		() => [
			() => ({
				validator(_, value) {
					if (value && !value.match(regexForStartLinks)) {
						return Promise.reject(new Error(t('linkMustStartWithHttp')));
					}
					return Promise.resolve();
				},
			}),
		],
		[],
	);

	return (
		<FormInput
			testId="DownloadAppAndroidUrlField"
			name="downloadAppAndroidUrl"
			label="downloadAppAndroidUrlLabel"
			disabled={!isShowCustomerLoyaltyProgramButtons}
			onChange={changeDownloadAppAndroidUrl}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(DownloadAppAndroidUrlField);
